/**
 * serviceErrorState — tiny global event bus so any fetch/axios layer
 * can publish a "service-degraded" signal and any UI component
 * (ServiceErrorBanner, toasts, etc.) can subscribe without prop
 * drilling. Intentionally NOT in a React context — auth.js needs to
 * publish from outside the React tree.
 */
const listeners = new Set();
let lastError = null;
let dismissedUntil = 0;

export function publishServiceError(payload) {
  // Respect a "dismissed for 5 min" cooldown so the banner doesn't
  // flash back the moment the user closes it.
  if (Date.now() < dismissedUntil) return;
  lastError = { ...payload, at: Date.now() };
  listeners.forEach((fn) => {
    try { fn(lastError); } catch (_e) { /* noop */ }
  });
}

export function dismissServiceError({ cooldownMs = 5 * 60 * 1000 } = {}) {
  dismissedUntil = Date.now() + cooldownMs;
  lastError = null;
  listeners.forEach((fn) => {
    try { fn(null); } catch (_e) { /* noop */ }
  });
}

export function subscribeServiceErrors(fn) {
  listeners.add(fn);
  // Replay last so a late-mounting subscriber sees current state.
  if (lastError) fn(lastError);
  return () => listeners.delete(fn);
}
